module.exports = __webpack_public_path__ + "static/media/profile-picture.a821a26c.jpg";